import { observer } from "mobx-react";
import { TitleComp } from "../../caf/components/titleComp";
import { Grid } from "@material-ui/core";
import { TextField } from "@roc/ui";

export const PersonalInformation = observer(({ personalInformation }) => {
  return (<Grid item xs={12}>
    <TitleComp title="Personal Information" />
    <Grid container spacing={2} style={{ marginTop: "22px" }}>
      <Grid item xs={12} sm={6}>
        <TextField
          testId="firstName"
          required
          variant="outlined"
          label="First Name"
          value={personalInformation?.firstName}
          fullWidth
          disabled={true}
          standaloneLabel={true}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          testId="lastName"
          required
          variant="outlined"
          label="Last Name"
          value={personalInformation?.lastName}
          fullWidth
          disabled={true}
          standaloneLabel={true}
        />
      </Grid>
    </Grid>
  </Grid>);
})